import React from "react";

import styles from "./History.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";

const History: React.FC = () => {
  return (
    <section className={styles.history}>
      <div className="container">
        {<PreviousPage currentPage="О нас" title="О компании" />}
        <div className={styles.info}>
          <p className={styles.text}>
            С 2019 года начали свою работу розничный магазин и склад в Москве. В 23 году открыли еще 2 магазина в Москве и
            Санкт-Петербурге. Мы сами разрабатываем дизайн, принты и расцветки будущих тканей. Сейчас у нас собственное
            производство.
          </p>
        </div>
      </div>
      <div className={styles.bg}>
        <img src="/img/main/about-us/bg.jpg" alt="bg" />
      </div>
      <div className="container">
        <div className={styles.shop}>
          <h2 className="title">Тканополис — магазин тканей и фурнитуры с многолетней историей.</h2>
          <p className={styles.text}>
            За 20 лет мы открыли в Ростове-на-Дону несколько розничных магазинов, оптовый склад, Showroom, наладили
            онлайн-продажи. <br /> С нами сотрудничают самые крупные фабрики по всему миру. <br /> Склад ежедневно пополняется
            новинками с самыми популярными расцветками и принтами. <br /> Благодаря совместной деятельности с зарубежными
            предприятиями, у нас есть возможность отгружать ткани не только по всей России и СНГ, но и во все страны мира
            непосредственно с производства.
          </p>
        </div>
        <div className={styles.whyChooseUs}>
          <h2 className="title">Почему выбирают нас</h2>
          <div className={styles.body}>
            <div className={styles.item}>
              <div className={styles.image}>
                <img src="/img/main/about-us/scale.svg" alt="icon" />
              </div>
              <h3 className={styles.subTitle}>Масштабы</h3>
              <p className={styles.description}>
                Разработаем по вашему заказу ткани эксклюзивно, без выпуска в открытую продажу.
              </p>
            </div>
            <div className={styles.item}>
              <div className={styles.image}>
                <img src="/img/main/about-us/uniq-design.svg" alt="icon" />
              </div>
              <h3 className={styles.subTitle}>Уникальный дизайн</h3>
              <p className={styles.description}>
                Разрабатываем дизайны для принтов, костюмных тканей, подбираем уникальную коллекцию
              </p>
            </div>
            <div className={styles.item}>
              <div className={styles.image}>
                <img src="/img/main/about-us/production.svg" alt="icon" />
              </div>
              <h3 className={styles.subTitle}>Производство</h3>
              <p className={styles.description}>
                Производим ткани на лучших фабриках мира: итальянских, турецких, а также азиатских.
              </p>
            </div>
            <div className={styles.item}>
              <div className={styles.image}>
                <img src="/img/main/about-us/exclusive.svg" alt="icon" />
              </div>
              <h3 className={styles.subTitle}>Эксклюзивные ткани</h3>
              <p className={styles.description}>
                Разработаем по вашему заказу ткани эксклюзивно, без выпуска в открытую продажу.
              </p>
            </div>
            <div className={styles.item}>
              <div className={styles.image}>
                <img src="/img/main/about-us/quality.svg" alt="icon" />
              </div>
              <h3 className={styles.subTitle}>Качество</h3>
              <p className={styles.description}>
                Все ткани проходят контроль качества и доп. обработку на фабриках, а мы лично тестируем все ткани, еще на этапе
                производства
              </p>
            </div>
            <div className={styles.item}>
              <div className={styles.image}>
                <img src="/img/main/about-us/guarantees.svg" alt="icon" />
              </div>
              <h3 className={styles.subTitle}>Гарантии</h3>
              <p className={styles.description}>
                Многолетний опыт даёт нам возможность предлагать только лучшее от проверенных поставщиков со всего мира
              </p>
            </div>
          </div>
        </div>
        <div className={styles.bg}>
          <img src="#" alt="bg" />
        </div>
        <div className={styles.uniqTextile}>
          <h2 className="title">Создаем уникальные ткани</h2>
          <div className={styles.body}>
            <div className={styles.item}>
              <h3 className={styles.subTitle}>
                Уникальность <div className={styles.divider} />
              </h3>
              <div className={styles.text}>
                <p>Наши ткани уникальны, т.к. поставщики работают по нашему заказу и требованиям.</p>
                <p>Также вы можете заказать у нас свой дизайн.</p>
                <p>Вся продукция при производстве проходит специальную обработку на усадку.</p>
              </div>
            </div>
            <div className={styles.item}>
              <h3 className={styles.subTitle}>
                Контроль качества <div className={styles.divider} />
              </h3>
              <div className={styles.text}>
                <p>
                  Из каждого вида ткани мы отшиваем изделия, проверяя таким образом, как она ведет себя при шитье, как смотрится
                  на модели, насколько удобна и приятна в носке.
                </p>
                <p>Мы уверены в качестве своей продукции и можем гарантировать его своим покупателям.</p>
              </div>
            </div>
            <div className={styles.item}>
              <h3 className={styles.subTitle}>Большой выбор фурнитуры</h3>
              <div className={styles.text}>
                <p>Также в нашем магазине вы всегда можете подобрать фурнитуру к вашим будущим изделиям.</p>
                <p>
                  У нас огромный выбор декоративной и технической фурнитуры от разных производителей, а также ассортимент швейных
                  принадлежностей и товаров для рукоделия.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default History;
